"use strict";

var _classCallCheck = require("/Users/joffreybourdieux/Documents/Devs/perso/joffreybourdieux.fr_V5/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/joffreybourdieux/Documents/Devs/perso/joffreybourdieux.fr_V5/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Grabber = void 0;

var Utils_1 = require("../../Utils");

var Modes_1 = require("../../Enums/Modes");

var Grabber = /*#__PURE__*/function () {
  function Grabber(container) {
    _classCallCheck(this, Grabber);

    this.container = container;
  }

  _createClass(Grabber, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container;
      var mouse = container.interactivity.mouse;
      var events = container.options.interactivity.events;

      if (!(events.onHover.enable && mouse.position)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      return Utils_1.Utils.isInArray(Modes_1.HoverMode.grab, hoverMode);
    }
  }, {
    key: "reset",
    value: function reset() {}
  }, {
    key: "interact",
    value: function interact() {
      var _a;

      var container = this.container;
      var options = container.options;
      var interactivity = options.interactivity;

      if (interactivity.events.onHover.enable && container.interactivity.status === Utils_1.Constants.mouseMoveEvent) {
        var mousePos = container.interactivity.mouse.position;

        if (mousePos === undefined) {
          return;
        }

        var distance = container.retina.grabModeDistance;
        var query = container.particles.quadTree.queryCircle(mousePos, distance);

        var _iterator = _createForOfIteratorHelper(query),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var particle = _step.value;
            var pos = particle.getPosition();
            var pointDistance = Utils_1.NumberUtils.getDistance(pos, mousePos);

            if (pointDistance <= distance) {
              var grabLineOptions = interactivity.modes.grab.links;
              var lineOpacity = grabLineOptions.opacity;
              var opacityLine = lineOpacity - pointDistance * lineOpacity / distance;

              if (opacityLine > 0) {
                var optColor = (_a = grabLineOptions.color) !== null && _a !== void 0 ? _a : particle.particlesOptions.links.color;

                if (!container.particles.grabLineColor) {
                  var linksOptions = container.options.interactivity.modes.grab.links;
                  container.particles.grabLineColor = Utils_1.ColorUtils.getLinkRandomColor(optColor, linksOptions.blink, linksOptions.consent);
                }

                var colorLine = Utils_1.ColorUtils.getLinkColor(particle, undefined, container.particles.grabLineColor);

                if (colorLine === undefined) {
                  return;
                }

                container.canvas.drawGrabLine(particle, colorLine, opacityLine, mousePos);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);

  return Grabber;
}();

exports.Grabber = Grabber;